<template>
<div v-role="'func'">
  <div v-if="this.$store.state.actividades.filter( a=>a.descricao === 'Matricula' && a.status_2 === 0).length">

           <v-card
    class="mx-auto"
    outlined
  >
  <div class="text-center">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="headline mb-1">Bloqueada</v-list-item-title>
      </v-list-item-content>

    </v-list-item>
  </div>

  </v-card>

  </div>
<div v-if="this.$store.state.actividades.filter( a=>a.descricao === 'Matricula' && a.status_2 === 1).length">
  <br>
  <v-card
    class="mx-auto"
    max-width="1000"
  >
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
    <v-card-text>
       <v-container fluid>
           <div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

        <v-row>
          <v-col class="d-flex" cols="12" sm="6" md="6" >
            <p class="display-1 text--primary">
               Definir director de Turma
            </p>

          </v-col>
        </v-row>
  </v-container>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <div class="text--primary">

          <v-row>

               <v-col class="d-flex" cols="12" sm="6" md="4">

                <v-autocomplete
                  v-model="editedItem.estudante"
                  :items="professores"
                  :loading="isLoading_"
                  :search-input.sync="search"
                  color="primary"
                  item-text="nome"
                  item-value="nome"
                  label="Nome do Professor"
                  placeholder="Digite o nome do professor"
                  prepend-icon="mdi-database-search"
                  return-object
                ></v-autocomplete>

                </v-col>
                 <v-col class="d-flex" cols="12" sm="6" md="4">
                    <v-autocomplete
                  v-model="editedItem.turma"
                  :items="turmas"
                  :loading="isLoading_"
                  :search-input.sync="searchTurmas"
                  color="primary"
                  item-text="turmadescricao"
                  item-value="turmadescricao"
                  label="Nome da Turma"
                  placeholder="Digite aqui"
                  prepend-icon="mdi-database-search"
                  return-object
                ></v-autocomplete>
                </v-col>

                 <v-col class="d-flex" cols="12" sm="6" md="2">

                 <v-btn fab :disabled="editedItem.estudante === null || editedItem.turma === null "  color="primary" small  @click="AdicionarTabela()"  ><v-icon  color="white" sa >add</v-icon></v-btn>

             </v-col>
               <v-col class="d-flex" cols="12" sm="6" md="2">
                     <v-progress-circular
                    v-if="progresso"
                    indeterminate
                    color="green"
                ></v-progress-circular>
               </v-col>
          </v-row>
          <v-row v-if="listaDeClassesPorLancarNotas.length">
            <v-col cols="12" sm="6" md="7"></v-col>
          <v-col cols="12" sm="6" md="2">
            <v-btn color="primary" :disabled="isLoading" @click="FinalizarOperacao()">Finalizar</v-btn>
          </v-col>
          </v-row>
          <v-row>
             <v-col class="d-flex" cols="12" sm="6" md="9">

                    <template>
                      <v-card
                        width="800"
                        >
                        <v-toolbar
                          color="#006699"
                          dark
                        >
                          <v-app-bar-nav-icon></v-app-bar-nav-icon>

                          <v-toolbar-title>{{(!listaDeClassesPorLancarNotas.length)?'Nenhum dados adicionado a tabela':'Dados adicionados a tabela'}}</v-toolbar-title>

                          <v-spacer></v-spacer>
                        </v-toolbar>
                             <v-list two-line>
      <v-list-item-group
        active-class="pink--text"
      >
        <template v-for="(item, index) in listaDeClassesPorLancarNotas">
          <v-list-item :key="item.title">
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <v-list-item-title v-text="item.professor.nome" ></v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <strong>Turma:</strong><v-list-item-action-text v-text="item.turma.turmadescricao" ></v-list-item-action-text>
                <v-btn color="primary" fab small @click="removerTabela(item)" >
                <v-icon
                  color="white"
                >
                  delete
                </v-icon>
                </v-btn>
              </v-list-item-action>
            </template>
          </v-list-item>

          <v-divider
            v-if="index + 1 < turmasAll.length"
            :key="index"
          ></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
                        </v-card>
                      </template>

             </v-col>

          </v-row>

      </div>
    </v-form>
    </v-card-text>

  </v-card>
</div>
</div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')

export default {
  data: () => ({
    items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    estudantes: [],
    professores: [],
    turmasAll: [],
    listaDeClassesPorLancarNotas: [],
    turmasFiltered: [],
    turmas: [],
    valid: true,
    jaMatriculado: '',
    classe: '',
    detalhe: '',
    progresso: false,
    isLoading: false,
    isLoading_: false,
    search: null,
    searchTurmas: null,
    exibe: false,
    acesso: [],
    descriptionLimit: 60,
    entries: [],
    search2: null,
    turma: null,
    filter: false,
    editedItem: {
      estudante: null,
      turma: null
    },
    ruleRequired: [value => value || 'campo obrigatorio']
  }),

  computed: {

    ListaActividades () {
      return ls.get('lista_actividades')
    },
    fields () {
      if (!this.model) return []

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    }
  },

  watch: {

    search (val) {
      // Items have already been loaded
    // this.estudantes = []
      // console.log('passouuuuuu' + this.estudantes.length)
      if (val.length > 3) {
      // Items have already been requested
        if (!this.professores.filter(t => t.nome.includes(val)).length) {
          this.professores = []
        }
        return this.PesquisaProfessores(val)
      }
    },

     searchTurmas (val) {
      // Items have already been loaded
    // this.estudantes = []
      // console.log('passouuuuuu' + this.estudantes.length)
      if (val.length > 3) {
      // Items have already been requested
        if (!this.turmas.filter(t => t.turmadescricao.includes(val)).length) {
          this.turmas = []
        }
        return this.PesquisaTurmas(val)
      }
    }

  },
  created () {
    this.InitializeTurmasRegistradas()
  },

  methods: {

    async Initialize (searchDB) {
      this.isLoading = true
      if (!this.estudantes.length) {
        if (searchDB) {
          var payload = '{ "find" : "' + searchDB + '" }'
        } else {
          payload = '{ "find":"all" }'
        }
        try {
          // this.isLoading = true
          this.estudantes = await axios
            .get('/EstudantesConfirmacao/' + payload)
            .then(res => res.data)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

  async  FinalizarOperacao (){
    try {
        this.isLoading = true
        let result = await axios
          .post('/definir-directorTurma',{items:this.listaDeClassesPorLancarNotas})
          .then(res => res.data)
        this.isLoading = false
        if(result.affectedRows >= 1){
            this.listaDeClassesPorLancarNotas = []
            this.$store.dispatch('textMessage', { 'msg': 'Professor definido como director de turma com sucesso', 'classMessage': 'msgSucess', 'timeout': 8000 })
        }else{
          this.$store.dispatch('textMessage', { 'msg': 'Ocorreu um erro ao tentar efectuar a operação', 'classMessage': 'msgError', 'timeout': 5000 })
        }
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', {msg: this.text,classMessage: 'msgError',timeout: 3000})
      }

       

    },

    async PesquisaProfessores (search) {
      try {
        this.isLoading = true
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }
        this.professores = await axios
          .get('/professorFindAll/' + payload)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    removerTabela (item){
       let index = this.listaDeClassesPorLancarNotas.indexOf(item)
       this.listaDeClassesPorLancarNotas.splice(index,1)
    },


    async PesquisaTurmas (search) {
      try {
        this.isLoading = true
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }
        this.turmas = await axios
          .get('/turmaSearch/' + payload)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    ListarEstudantes (item) {
      alert('funciona')
    },

    AdicionarTabela () {
      
      if(this.turmasAll.filter(t=>t.fkTurma === this.editedItem.turma.pkTurma).length){
        this.$store.dispatch('textMessage', {msg: 'Esta turma já foi atribuida, por favor selecione uma turma diferente',classMessage: 'msgError',timeout: 3000})         
      }else{
           if(this.listaDeClassesPorLancarNotas.filter(t=>t.turma.pkTurma === this.editedItem.turma.pkTurma).length){
              this.$store.dispatch('textMessage', {msg: 'Esta turma já foi selecionada, por favor selecione uma turma diferente',classMessage: 'msgError',timeout: 3000})
          }else{
            this.listaDeClassesPorLancarNotas.push({professor:this.editedItem.estudante,turma:this.editedItem.turma})
            this.editedItem.estudante = null
            this.editedItem.turma = null
          }
      }
    },

    async save () {
      if ((this.$refs.form.validate())) {
        this.progresso = true
        let params =
                {
                  idmatricula: this.editedItem.objecto.idMatricula,
                  idturma: this.editedItem.Turma.idTurma,
                  pkPessoa: this.editedItem.objecto.pkPessoa,
                  idanolectivo: this.editedItem.objecto.anolectivo,
                  pkTurma: this.editedItem.Turma.pkTurma,
                  idcurso: this.editedItem.Turma.idCurso,
                  bi: this.editedItem.objecto.pkPessoa,
                  idanoacademico: this.editedItem.Turma.idAno_Academico,
                  resultado: (this.editedItem.objecto.resultado === 'Transita') ? 1 : 0,
                  descricao_resultado: this.editedItem.objecto.resultado,
                  fromtransferencia: 0,
                  fromMudancaclasse: 0,
                  ultimoAnoFeito: this.editedItem.objecto.ControloUltimoParaOproximoAno
                }

        try {
          // this.isLoading = true
          let msg = await axios
            .post('/confirmacaoInsertOrUpdate', params)
            .then(res => res.data)
          if(!msg.length){
            this.Limpar('CONFIRMAÇÃO EFECTUADA COM SUCESSO')
            this.progresso = false
            this.text = 'CONFIRMAÇÃO EFECTUADA COM SUCESSO'
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          }else{
              this.text = 'Ocorreu um erro ao tentar efectuar a operação'
              this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          }
          
        } catch (error) {
          this.progresso = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    Limpar (msg) {
      if (msg === 'CONFIRMAÇÃO EFECTUADA COM SUCESSO') {
        const index = this.estudantes.indexOf(this.editedItem.objecto)
        this.estudantes.splice(index, 1)
        // eslint-disable-next-line no-unused-expressions
        this.editedItem.objecto = null
        this.editedItem.Turma = null
        this.classe = ''
        this.$refs.form.resetValidation()
        this.turmaFindWithEstudanteCount()
      }
    },

    async InitializeTurmasRegistradas (search) {
      let payload
      try {
        this.isLoading = true
        if (!search) {
          payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.turmasAll = await axios
          .get('/listarDirectorTurmas/' + payload)
          .then(res => res.data)
          console.log(this.turmasAll);
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    

    async verificaSeJaConfirmado(){
      console.log(this.editedItem.objecto);
       try {
        this.jaMatriculado = await axios
          .post('/Estudante-ja-Confirmado', this.editedItem.objecto)  
          .then(res => res.data)
       } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async ObterClasse () {
      if (parseInt(this.editedItem.objecto.anoacademico) === 1) { this.classe = '10ª Classe' }
      if (parseInt(this.editedItem.objecto.anoacademico) === 2) { this.classe = '11ª Classe' }
      if (parseInt(this.editedItem.objecto.anoacademico) === 3) { this.classe = '12º Classe' }
      if (parseInt(this.editedItem.objecto.anoacademico) === 4) { this.classe = '13ª Classe' }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },
    async loadTurmaComb () { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.ObterClasse()
      this.verificaSeJaConfirmado().then(()=>{
          this.turmasFiltered = []
          if(this.jaMatriculado <=0 ){

            this.editedItem.Turma = null
          if (this.editedItem.objecto.resultado === 'Transita') { this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem.objecto.idCurso && t.idAno_Academico === (parseInt(this.editedItem.objecto.anoacademico) + 1)) } else { this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem.objecto.idCurso && t.idAno_Academico === parseInt(this.editedItem.objecto.anoacademico)) }

          if (this.turmasFiltered.length) { this.detalhe = '' } else { this.detalhe = 'Não existem turmas cadastradas para este curso e classe!' }

          }else{
               this.$store.dispatch('textMessage', {msg: 'Estudante já confirmado no anolectivo actual',classMessage: 'msgError',timeout: 8000})
          }
      })
    }

  }
}
</script>
